// Calculates and adds vh variable as global css variable.
export function addVhSupportForMobile(): void {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
